import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {loginActions, localStateManagementActions} from 'shared/Actions';

import CheckInbox from './CheckInbox';

export const mapStateToProps = (state) => ({
    loginState: state.loginData,
    otpDetails: state.localStateManagementReducerData.otpDetails,
});

const mapDispatchToProps = {
    ...localStateManagementActions,
    ...loginActions,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CheckInbox));
